import { useQuery } from "@tanstack/react-query";
import * as api from "../api/client";
import type { ReleasesFilter } from "../api/types";

export const useIndicators = (country?: string, category?: string) =>
  useQuery({
    queryKey: ["indicators", country, category],
    queryFn: () => api.getIndicators(country, category),
  });

export const useIndicator = (id: string) =>
  useQuery({
    queryKey: ["indicator", id],
    queryFn: () => api.getIndicator(id),
    enabled: !!id,
  });

export const useReleases = (filter: ReleasesFilter = {}) =>
  useQuery({
    queryKey: ["releases", filter],
    queryFn: () => api.getReleases(filter),
  });

export const useRelease = (id: string) =>
  useQuery({
    queryKey: ["release", id],
    queryFn: () => api.getRelease(id),
    enabled: !!id,
  });

export const useCalendar = (week: "current" | "next" = "current", country?: string) =>
  useQuery({
    queryKey: ["calendar", week, country],
    queryFn: () => api.getCalendar(week, country),
    staleTime: 5 * 60 * 1000, // 5分キャッシュ
  });

export const useIndicatorReleases = (indicatorId: string, page = 1) =>
  useQuery({
    queryKey: ["releases", { indicator_id: indicatorId, page }],
    queryFn: () => api.getReleases({ indicator_id: indicatorId, page, size: 24 }),
    enabled: !!indicatorId,
  });
